import { SERVICES, TIME_RANGE } from "constants/constants";

import { getAPIService, postAPIService } from "./BaseServce";
import { Export } from "../models/Export";

export const getExports = async (
  searchTerm: string | null,
  services: SERVICES[],
  timeRange: TIME_RANGE,
  page: number,
) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  if (searchTerm) params.append("search_term", searchTerm);
  if (timeRange) params.append("time_range", timeRange);

  const allServices = services.length ? services : Object.values(SERVICES);
  allServices.forEach((s) => params.append("services", s));

  const res = await getAPIService("/exports", params);
  return res.data;
};

export const createExport = async (
  projectId: number,
  layerIds: number[],
  exportModes: string[],
) => {
  const res = await postAPIService(`/exports`, {
    project_id: projectId,
    layer_ids: layerIds,
    export_modes: exportModes,
  });
  return res.data as Export[];
};

export const setLastDownload = async (exportId: number, type?: string) => {
  const res = await postAPIService("/export/last-download", {
    export_id: exportId,
    type,
  });
  return res.data as { url: string | null };
};

export const getBulkExportLayers = async (
  projectId: number,
  service: SERVICES,
  filter: string,
) => {
  const res = await getAPIService("/bulk-export", {
    project_id: projectId,
    service,
    filter,
  });
  return res.data as {
    shots: {
      id: number;
      name: string;
      shot_preview_image_url: string;
      frame_count: number;
      resolution: number;
      source: string;
      is_demo_shot: boolean;
    }[];
    layers: {
      id: number;
      name: string;
      cover_image_url: string;
      shot_id: number;
      inference_id: number;
      frame_number: number;
      last_export: string | null;
      export_count: number;
      is_autopilot_layer: boolean;
    }[];
  };
};
